module.exports = __webpack_public_path__ + "assets/images/img_contact_group_example.jpg";